import { render } from "./ConfirmandoTelefone.vue?vue&type=template&id=56d8821d"
import script from "./ConfirmandoTelefone.vue?vue&type=script&lang=js"
export * from "./ConfirmandoTelefone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__